<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <q-form ref="editForm">
        <c-card title="보호구 지급 상세" class="cardClassDetailForm">
          <template slot="card-button">
            <q-btn-group outline>
              <c-qr-btn
                v-if="editable && !disabled && data.statusCd==='SSC0000010'"
                :mobileUrl="'/sop/sas/safetyGear?requestGiveInfoId='+param.requestGiveInfoId"
              ></c-qr-btn>
              <c-btn
                v-if="editable && !disabled && signFlag"
                :url="completeUrl"
                :isSubmit="isComplete"
                :param="data"
                mappingType="PUT"
                label="지급완료"
                icon="check"
                @beforeAction="completeData"
                @btnCallback="completeCallback" 
              />
              <c-btn
                v-if="editable && !disabled && isOld" 
                label="삭제" 
                icon="delete_forever" 
                @btnClicked="removeData" />
              <c-btn
                v-if="editable && !disabled"
                :url="saveUrl"
                :isSubmit="isSave"
                :param="data"
                :mappingType="saveType"
                label="저장"
                icon="save"
                @beforeAction="saveData"
                @btnCallback="saveCallback" 
              />
            </q-btn-group>
          </template>
          <template slot="card-detail">
            <div class="col-2">
              <c-datepicker
                :required="true"
                label='지급일'
                :disabled="disabled"
                :editable="editable"
                default="today"
                name="giveDate"
                v-model="data.giveDate"
              />
            </div>
            <div class="col-2">
              <c-plant
                v-if="param.isRequest==='N'"
                type="edit"
                :required="true"
                label='사업장'
                :disabled="disabled"
                :editable="editable"
                name="plantCd"
                v-model="data.plantCd"
              />
            </div>
            <div class="col-2">
              <c-dept
                :required="true"
                label='지급부서'
                :disabled="disabled"
                :editable="editable"
                :plantCd="data.plantCd"
                name="giveDeptCd"
                v-model="data.giveDeptCd"
              />
            </div>
            <div class="col-2">
              <c-field
                :required="true"
                label='불출담당자'
                :disabled="disabled"
                :editable="editable"
                :plantCd="data.plantCd"
                name="giveUserId"
                v-model="data.giveUserId"
              />
            </div>
            <div class="col-2">
              <c-field
                :required="true"
                label='수령인'
                :disabled="disabled"
                :editable="editable"
                :plantCd="data.plantCd"
                name="recipientId"
                v-model="data.recipientId"
              />
            </div>
          </template>
        </c-card>
      </q-form>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="table"
        title="보호구 지급 목록"
        tableId="table"
        :columns="gridColumns"
        :data="data.detailList2"
        :merge="grid.merge"
        :isFullScreen="false"
        :columnSetting="false"
        :filtering="false"
        :usePaging="false"
        :isExcelDown="false"
        :editable="editable&&!disabled"
        gridHeight="600px"
        selection="multiple"
        rowKey="giveListId"
      >
        <template slot="table-button">
          <div>
            <q-btn-group outline>
              <c-btn v-if="editable&&!disabled&&param.isRequest==='Y'" label="신청 보호구 선택" icon="save_alt" @btnClicked="addRequestGear" />
              <c-btn v-if="editable&&!disabled" label="추가" icon="add" @btnClicked="addGear" />
              <c-btn v-if="editable&&!disabled" label="제외" icon="remove" @btnClicked="removeGear" />
            </q-btn-group>
          </div>
        </template>
        <template v-slot:customArea="{ props, col }">
          <template v-if="col.name === 'userArray'">
            <c-multi-field 
              :editable="editable"
              :disabled="disabled"
              :userInfo.sync="userInfo"
              isArray
              type="user"
              label="" 
              :name="`userArray${props.rowIndex}`" 
              v-model="props.row[col.name]"
              @dataChange="dataChange(props, col)" />
          </template>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'safety-gear-give-info',
  props: {
    param: {
      type: Object,
      default: () => ({
        requestGiveInfoId: '',
        stepCd: '',
        plantCd: '',
        giveTypeCd: '',
        isRequest: 'Y'
      }),
    },
  },
  data() {
    return {
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      data: {
        requestGiveInfoId: '',
        plantCd: null,
        requestDate: '',
        requestDeptCd: '',
        requestDeptName: '',
        requestUserName:'',
        requestUserId: '',
        requestItems: '',
        giveItems: '',
        giveDate: '',
        giveTypeCd: '',
        giveDeptCd: '',
        giveUserId: '',
        giveTypeName: '',
        giveDeptName: '',
        giveUserName: '',
        statusCd: '',
        statusName: '',
        sysApprovalRequestId: '',
        recipientId: '',
        recipientName: '',
        recipientSign: '',
        signDt: '',
        detailList: [], // 요청물품리스트
        deleteDetailList: [],
        detailList2: [], // 지급물품리스트
        deleteDetailList2: [],
      },
      grid: {
        data: [],
      },
      searchParam: {
        plantCd: null,
        giveDt: '',
        safetySuppliesGiveId: '',
      },
      editable: true,
      isApproval: false,
      saveUrl: '',
      saveType: 'POST',
      isSave: false,
      completeUrl: '',
      isComplete: false,
      getUrl: '',
      deleteUrl: '',
    };
  },
  computed: {
    userInfo() {
      return {
        userItems: [],
        userText: 'userName',
        userValue: 'userId',
      }
    },
    disabled() {
      return this.data.statusCd === 'SSC0000015'
    },
    signFlag() {
      return Boolean(this.data.recipientSign)
    },
    isOld() {
      return Boolean(this.param.requestGiveInfoId)
    },
    gridColumns() {
      let cols = [
        {
          name: 'safetyTypeName',
          field: 'safetyTypeName',
          label: '보호구종류',
          style: 'width:120px',
          align: 'center',
          setHeader: true,
          sortable: false,
        },
        {
          name: 'safetyGearName',
          field: 'safetyGearName',
          label: '보호구명',
          style: 'width:200px',
          align: 'left',
          setHeader: true,
          sortable: false,
        },
        {
          required: true,
          name: 'giveCount',
          field: 'giveCount',
          label: '지급수량',
          style: 'width:80px',
          align: 'right',
          type: 'number',
          setHeader: true,
          sortable: false,
        },
        {
          name: 'remarks',
          field: 'remarks',
          label: '비고',
          style: 'width:250px',
          align: 'left',
          type: 'text',
          setHeader: true,
          sortable: false,
        },
      ];
      if (this.data.giveTypeCd === 'SGT0000001') {
        // 신청지급인 경우 신청수량 표시
        cols.splice(2, 0, {
          name: 'requestCount',
          field: 'requestCount',
          label: '신청수량',
          style: 'width:80px',
          align: 'right',
          type: 'cost',
          sortable: false,
        },)
      }
      return cols;
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.getUrl = selectConfig.sop.sas.give.get.url;
      this.saveUrl = transactionConfig.sop.sas.give.insert.url;
      this.deleteUrl = transactionConfig.sop.sas.request.delete.url;
      this.completeUrl = transactionConfig.sop.sas.give.complete.url;

      this.getDetail();
    },
    getDetail() {
      if (this.param.requestGiveInfoId) {
        this.$http.url = this.$format(this.getUrl, this.param.requestGiveInfoId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.$_.extend(this.data, _result.data);
          if (!_result.data.detailList2 || _result.data.detailList2.length === 0) {
            this.$_.forEach(_result.data.detailList, item => {
              this.data.detailList2.push({
                giveListId: uid(),
                requestGiveInfoId: this.param.requestGiveInfoId,
                safetyGearId: item.safetyGearId,
                safetyTypeName: item.safetyTypeName,
                safetyGearName: item.safetyGearName,
                requestCount: item.requestCount,
                giveCount: item.requestCount,
                remarks: '',
                regUserId: this.$store.getters.user.userId,
                editFlag: 'C',
              })
            })
          } 
          if(this.data.statusCd === 'SSC0000005') {
            this.data.giveDate = this.$comm.getToday()
            this.data.giveUserId = this.$store.getters.user.userId;
            this.data.giveDeptCd = this.$store.getters.user.deptCd
          }
        },);
      } else {
        this.data.giveDate = this.$comm.getToday()
        this.data.giveTypeCd = this.param.giveTypeCd 
        this.data.giveUserId = this.$store.getters.user.userId;
        this.data.giveDeptCd = this.$store.getters.user.deptCd
      }
    },
    saveData() {
      if (this.isOld) {
        this.data.chgUserId = this.$store.getters.user.userId
        this.saveType = 'PUT';
      } else {
        this.data.regUserId = this.$store.getters.user.userId
        this.saveType = 'POST';
      }

      if (!this.data.detailList2 || this.data.detailList2.length == 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', 
          message: '지급할 보호구를 하나 이상 등록하세요.', 
          type: 'warning', // success / info / warning / error
        });
        return;
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          if (this.$comm.validTable(this.gridColumns, this.data.detailList2)) {
            window.getApp.$emit('CONFIRM', {
              title: '확인',
              message: '저장하시겠습니까?', 
              type: 'info', // success / info / warning / error
              // 확인 callback 함수
              confirmCallback: () => {
                this.isSave = !this.isSave;
              },
              // 취소 callback 함수
              cancelCallback: () => {
              },
            });
          }
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(result) {
      this.param.requestGiveInfoId = result.data
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    completeData() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          if (this.$comm.validTable(this.gridColumns, this.data.detailList2)) {
            window.getApp.$emit('CONFIRM', {
              title: '확인',
              message: '지급완료 하시겠습니까?',
              type: 'info', // success / info / warning / error
              // 확인 callback 함수
              confirmCallback: () => {
                this.data.chgUserId = this.$store.getters.user.userId
                this.isComplete = !this.isComplete;
              },
              // 취소 callback 함수
              cancelCallback: () => {
              },
            });
          }
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    completeCallback(result) {
      this.param.requestGiveInfoId = result.data
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    addRequestGear() {
      this.popupOptions.title = '신청 보호구 검색'; 
      this.popupOptions.param = {
        type: 'multiple',
        requestGiveInfoId: this.param.requestGiveInfoId,
      };
      this.popupOptions.target = () => import(`${'./safetyRequestGearPop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeGearRequestPopup;
    },
    closeGearRequestPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.data.detailList2, { safetyGearId: item.safetyGearId }) === -1) {
            this.data.detailList2.push({
              giveListId: uid(),
              requestGiveInfoId: this.param.requestGiveInfoId,
              safetyGearId: item.safetyGearId,
              safetyTypeName: item.safetyTypeName,
              safetyGearName: item.safetyGearName,
              giveCount: item.requestCount,
              userArray: [],
              remarks: '',
              regUserId: this.$store.getters.user.userId,
              editFlag: 'C'
            })
          }
        })
      }
    },
    addGear() {
      this.popupOptions.title = '보호구 검색'; 
      this.popupOptions.param = {
        type: 'multiple',
        plantCd: this.data.plantCd,
      };
      this.popupOptions.target = () => import(`${'./safetyGearPop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeGearPopup;
    },
    closeGearPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.data.detailList2, { safetyGearId: item.safetyGearId }) === -1) {
            this.data.detailList2.push({
              giveListId: uid(),
              requestGiveInfoId: this.param.requestGiveInfoId,
              safetyGearId: item.safetyGearId,
              safetyTypeName: item.safetyTypeName,
              safetyGearName: item.safetyGearName,
              giveCount: '',
              userArray: [],
              remarks: '',
              regUserId: this.$store.getters.user.userId,
              editFlag: 'C'
            })
          }
        })
      }
    },
    removeGear() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', 
          message: '선택된 항목이 없습니다.', 
          type: 'warning', // success / info / warning / error
        });
      } else {
        if (!this.data.deleteDetailList2) {
          this.data.deleteDetailList2 = []
        }
        this.$_.forEach(selectData, item => {
          if (this.$_.findIndex(this.data.deleteDetailList2, { giveListId: item.giveListId }) === -1
            && item.editFlag !== 'C') {
              this.data.deleteDetailList2.push(item)
          }
          this.data.detailList2 = this.$_.reject(this.data.detailList2, item)
        });
        this.$refs['table'].$refs['compo-table'].clearSelection();
      }
    },
    dataChange(props) {
      if (props.row['editFlag'] !== 'C') {
        props.row['editFlag'] = 'U'
        props.row['chgUserId'] = this.$store.getters.user.userId
      }
    },
    removeData() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?', 
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.param.requestGiveInfoId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('emitStep', {
              name: 'closePopup',
              param: {},
            })
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
  },
};
</script>